import catSvg from '../../assets/icons/avatars/cat.svg';
import bearSvg from '../../assets/icons/avatars/bear.svg';
import dogSvg from '../../assets/icons/avatars/dog.svg';
import bunnySvg from '../../assets/icons/avatars/bunny.svg';
import tigerSvg from '../../assets/icons/avatars/tiger.svg';
import elephantSvg from '../../assets/icons/avatars/elephant.svg';
import parrotSvg from '../../assets/icons/avatars/parrot.svg';
import monkeySvg from '../../assets/icons/avatars/monkey.svg';
import dinosaurSvg from '../../assets/icons/avatars/dinosaur.svg';

export type ChildAvatarKey =
  | 'cat'
  | 'bear'
  | 'dog'
  | 'bunny'
  | 'tiger'
  | 'elephant'
  | 'parrot'
  | 'monkey'
  | 'dinosaur';

export interface ChildAvatar {
  key: ChildAvatarKey;
  label: string;
  src: string;
}

export const CHILD_AVATARS: ChildAvatar[] = [
  { key: 'cat', label: 'Cat', src: catSvg },
  { key: 'bear', label: 'Bear', src: bearSvg },
  { key: 'dog', label: 'Dog', src: dogSvg },
  { key: 'bunny', label: 'Bunny', src: bunnySvg },
  { key: 'tiger', label: 'Tiger', src: tigerSvg },
  { key: 'elephant', label: 'Elephant', src: elephantSvg },
  { key: 'parrot', label: 'Parrot', src: parrotSvg },
  { key: 'monkey', label: 'Monkey', src: monkeySvg },
  { key: 'dinosaur', label: 'Dinosaur', src: dinosaurSvg },
];

/**
 * Get SVG source by avatar key
 */
export function getChildAvatarSrc(key: string): string | undefined {
  return CHILD_AVATARS.find((a) => a.key === key)?.src;
}
